/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useDxpFrameStore } from 'dxpConsoleCore-mf/State';
import { DxpCapability } from '../../Constants/DxpCapabilities/defs/DxpCapability.defs';
import { DxpCapabilityItem } from '../../Constants/DxpCapabilities/defs/DxpCapabilityItem.defs';
import { replaceTenantParam } from '../ReplaceTenantParam/ReplaceTenantParam';

/**
 * Get a generated capability path to the chosen screen.
 * @param {string} screenPath The web path for the screen within the capability.
 * @param {DxpCapabilityItem} [targetCapability] The specified DXP capability. Defaults to state value.
 * @export
 * @returns {string} A generated capability path for the chosen screen.
 */
export const getCapabilityPath = (screenPath: string, targetCapability?: DxpCapabilityItem): string => {
  const { capability }: { capability: DxpCapability | null } = useDxpFrameStore.getState();
  let capabilityPath = ``;

  if (capability && capability.path) {
    capabilityPath = replaceTenantParam(capability.path);
  }

  // Allow override for a specific capability
  if (targetCapability) {
    capabilityPath = replaceTenantParam(targetCapability.path);
  }

  return `${capabilityPath}${screenPath}`;
};
